export function IlustracaoAlvo(props) {
  return (
    <svg
      width={70}
      height={71}
      viewBox="0 0 70 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.745 57.48c14.172 1.543 55.457-12.99 38.108-37.214-17.35-24.224-50.339.353-52.044 14.9-1.7 14.547 3.602 21.191 13.936 22.314z"
        fill="#FFE4CF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.115 35c0 11.108-9.006 20.113-20.114 20.113-11.11 0-20.114-9.005-20.114-20.113 0-11.109 9.005-20.114 20.114-20.114 11.108 0 20.114 9.005 20.114 20.114z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.981 35c0 8.273-6.706 14.981-14.98 14.981-8.274 0-14.981-6.708-14.981-14.981 0-8.274 6.707-14.981 14.98-14.981 8.275 0 14.981 6.707 14.981 14.981z"
        fill="#FFFFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.962 35a7.962 7.962 0 11-15.925 0 7.962 7.962 0 0115.925 0z"
        fill="#FF7A5C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.677 14.914l-4.604 4.604v5.396h5.604l5.458-5.459h-5.53V13.83l-.928 1.084z"
        fill="#FFFFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.171 26.204a.939.939 0 00-1.241-.486.94.94 0 00-.486 1.242 19.99 19.99 0 011.67 8.04c0 11.09-9.023 20.113-20.114 20.113-11.091 0-20.114-9.023-20.114-20.113 0-11.091 9.023-20.114 20.114-20.114 2.801 0 5.509.563 8.051 1.674.119.053.246.08.375.08a.945.945 0 00.378-1.808A21.83 21.83 0 0035 13c-12.131 0-22 9.869-22 22s9.869 22 22 22 22-9.869 22-22a21.83 21.83 0 00-1.829-8.796z"
        fill="#B3472E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.623 23.076a.938.938 0 00.858-.569.937.937 0 00.014-.722.93.93 0 00-.5-.519A14.863 14.863 0 0035 20.019c-8.261 0-14.981 6.72-14.981 14.981 0 8.26 6.72 14.981 14.98 14.981 8.261 0 14.981-6.721 14.981-14.981 0-2.084-.419-4.098-1.245-5.989a.942.942 0 00-1.742.034.934.934 0 00.014.721A12.976 12.976 0 0148.095 35c0 7.22-5.874 13.094-13.094 13.094-7.221 0-13.095-5.874-13.095-13.094 0-7.221 5.873-13.096 13.095-13.096 1.82 0 3.584.367 5.24 1.09a.94.94 0 00.382.082z"
        fill="#B3472E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35 28.923c.415 0 .825.042 1.218.123a.951.951 0 001.111-.739.947.947 0 00-.738-1.112 8.053 8.053 0 00-1.59-.158c-4.39 0-7.963 3.573-7.963 7.963 0 4.39 3.572 7.962 7.962 7.962S42.962 39.39 42.962 35c0-.539-.054-1.078-.162-1.603a.948.948 0 00-1.112-.734.944.944 0 00-.735 1.113A6.082 6.082 0 0135 41.075 6.082 6.082 0 0128.924 35 6.084 6.084 0 0135 28.923z"
        fill="#B3472E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.77 20.139c0-.122.049-.239.136-.325l2.807-2.808a.461.461 0 01.787.326v2.226c0 .52.423.943.943.943h2.226a.46.46 0 01.326.786l-2.808 2.808a.462.462 0 01-.326.135h-3.63a.46.46 0 01-.46-.461v-3.63zm-1.812-.941a.928.928 0 00-.074.36v5.033c0 .123-.048.24-.135.326l-9.415 9.416a.945.945 0 00.667 1.61c.252 0 .489-.099.667-.277l9.415-9.415a.463.463 0 01.326-.135h5.034a.952.952 0 00.669-.278l5.61-5.612a.948.948 0 00.204-1.029.939.939 0 00-.868-.582h-4.212a.46.46 0 01-.46-.461v-4.211a.945.945 0 00-.943-.942.959.959 0 00-.67.277l-5.611 5.612a.926.926 0 00-.204.308z"
        fill="#B3472E"
      />
    </svg>
  );
}
